import { render, staticRenderFns } from "./MixResults.vue?vue&type=template&id=98442862&scoped=true"
import script from "./MixResults.vue?vue&type=script&lang=ts"
export * from "./MixResults.vue?vue&type=script&lang=ts"
import style0 from "./MixResults.vue?vue&type=style&index=0&id=98442862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98442862",
  null
  
)

export default component.exports